import { createApi } from '@reduxjs/toolkit/query/react';
import { format } from 'url';

import { TagTypesEnum } from '@enum/tag-types.enum';
import { LogFilterInterface, RequestInterface } from '@interface/logs/logs.interface';
import { PaginationRequestInterface, ResponseDataInterface } from '@interface/logs/response-data.interface';
import { apiQueryAuth } from '@util/api/api-query-auth';
import { queryBuilder } from '@util/api/query-builder';

export const logsApplicationApi = createApi({
  reducerPath: 'logs-application-api',
  tagTypes: [TagTypesEnum.ApplicationRequest],
  baseQuery: apiQueryAuth('/', true),
  endpoints: (build) => ({
    loadRequests: build.query<
      ResponseDataInterface<RequestInterface[]>,
      (PaginationRequestInterface & LogFilterInterface) | void
    >({
      query: (params: (PaginationRequestInterface & LogFilterInterface) | void = {}) => {
        const { pagination, filter } = params || {};
        return format({
          pathname: '/requests/application-requests',
          query: queryBuilder({ ...pagination, ...filter }),
        });
      },
      providesTags: [TagTypesEnum.ApplicationRequest],
    }),
  }),
});
